import React from 'react';
import { ReduxState } from 'react-admin';
import { useSelector } from 'react-redux';
import WelcomeScreen from '../Welcome';
import BaseDashboard from "./Dashboard";
import { getActiveMembership } from "@src/components/Common/utils";
import { Pov, usePov } from "@src/components/Common/pov";
import { DashboardProps } from "@src/types";

/**
 * Which endpoints the dashboard reads, per point of view.
 *
 * Admin is the Service Owner dashboard widened to the platform, and is written
 * here as exactly that: the same point of view and the same statistics
 * endpoint, plus `allTeams`. What it adds is the filters the Service Owner view
 * has no use for — that view is already inside one team, so a team filter would
 * be a filter on a single value — and `browse_services`, the service listing
 * that is not scoped to a point of view and so already spans every team.
 */
const DASHBOARDS: Record<Pov, DashboardProps> = {
  CONSUMER: {
    pov: 'CONSUMER',
    statisticsResource: 'consumer_statistics',
    applicationsResource: 'applications',
    servicesResource: 'consumer_services',
  },
  SERVICE_OWNER: {
    pov: 'SERVICE_OWNER',
    statisticsResource: 'serviceowner_statistics',
    teamsResource: 'consumer_teams',
    applicationsResource: 'owner_applications',
    servicesResource: 'services',
  },
  ADMIN: {
    pov: 'SERVICE_OWNER',
    allTeams: true,
    statisticsResource: 'serviceowner_statistics',
    teamsResource: 'all_teams',
    applicationsResource: 'owner_applications',
    servicesResource: 'browse_services',
  },
};

const Dashboard = () => {
  const welcomeScreenShown = useSelector((state: ReduxState) => state.ui.welcomeScreenShown);
  const pov = usePov();
  const activeMembership = getActiveMembership()

  return (
    <>
      <BaseDashboard {...(DASHBOARDS[pov] || DASHBOARDS.CONSUMER)} />
      {!activeMembership?.active  &&  !welcomeScreenShown && <WelcomeScreen />}
    </>
  )
}

export default Dashboard;
